<template>
    <div class="desktop-main">
        <div class="admin-body">
            <el-form ref="form" :model="tableParams" label-width="80px" :inline="true">
                <el-form-item label="状态">
                    <el-select v-model="tableParams.status" placeholder="请选择状态" clearable>
                        <el-option :key="0" label="待用" :value="0"></el-option>
                        <el-option :key="1" label="上架" :value="1"></el-option>
                        <el-option :key="2" label="下架" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-select v-model="tableParams.orderBy" placeholder="请选择排序" clearable>
                        <el-option :key="0" label="创建日期" value=""></el-option>
                        <el-option :key="1" label="上屏日期" value="startTime"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="newQueryTaskClick">查询</el-button>
                    <el-button type="primary" @click="insertTaskClick">新增</el-button>
                    <el-button type="primary" @click="batchOnlineClick">批量上架</el-button>
                    <el-button type="primary" @click="batchOfflineClick">批量下架</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData.list"
                stripe
                style="width: 100%"
                @selection-change="handleSelectionChange">
                 <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="id"
                    label="ID"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="价格"
                    width="100">
                    <template slot-scope="scope">
                        <span style="color: #DE5DB5; font-weight: 600;">{{scope.row.price}}</span>元
                    </template>
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0" style="color: gray; font-weight: 600;">待用</span>
                        <span v-if="scope.row.status == 1" style="color: green; font-weight: 600;">上架</span>
                        <span v-if="scope.row.status == 2" style="color: red; font-weight: 600;">下架</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="count"
                    label="总数量"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="useCount"
                    label="已占数量"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="unUseCount"
                    label="剩余数量"
                    width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.unUseCount >= 10" style="color: black; font-weight: 400;">{{ scope.row.unUseCount }}</div>
                        <div v-if="scope.row.unUseCount < 10 && scope.row.unUseCount > 0" style="color: orange; font-weight: 400;">{{ scope.row.unUseCount }}</div>
                        <div v-if="scope.row.unUseCount == 0" style="color: red; font-weight: 600;">{{ scope.row.unUseCount }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editTaskInfoClick(scope.row)" type="primary" size="small">编辑</el-button>
                        <el-button @click="toggleStatusClick(scope.row)" type="warning" size="small">切换状态</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="form-pagination">
                <el-pagination
                    :current-page="tableData.pageNum"
                    :page-size="tableData.pageSize"
                    layout="total, prev, pager, next"
                    :total="tableData.total"
                    @prev-click="changePage(-1)"
                    @next-click="changePage(1)"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>

        <el-dialog :title="dialogTaskInfo.newUpdateTitle" :visible.sync="dialogTaskInfo.newUpdateVisible" width="40%">
            <div class="dialog-person-body">
                    <el-form ref="form" :model="dialogTaskInfo.taskInfo" label-width="80px">
                        <el-form-item label="名称">
                            <el-input v-model="dialogTaskInfo.taskInfo.name"></el-input>
                        </el-form-item>
                        <el-form-item label="上屏日期">
                            <el-date-picker
                                v-model="selectDate"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="数量">
                            <el-input v-model="dialogTaskInfo.taskInfo.count"></el-input>
                        </el-form-item>
                        <el-form-item label="价格">
                            <el-input v-model="dialogTaskInfo.taskInfo.price"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="dialogTaskInfo.taskInfo.status" placeholder="请选择状态" clearable>
                                <el-option :key="0" label="待用" :value="0"></el-option>
                                <el-option :key="1" label="上架" :value="1"></el-option>
                                <el-option :key="2" label="下架" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="newUpdateTaskClick">保存</el-button>
                        </el-form-item>
                    </el-form>
                </div>
        </el-dialog>
    </div>
</template>

<script>
import NProgress from 'nprogress'
import { queryHandDateByPageApi, addOrUpdateHandDateApi, updateHandDateStatusApi, batchUpdateDateStatusApi } from '@/api/api';

    export default {
        components: { 
        },
        data() {
            return {
                tableParams: {
                    status: '',
                    queryStartTimes: [],
                    orderBy: '',
                },
                tableData: {
                    list: [],
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                dialogTaskInfo: {
                    newUpdateTitle: '新增',
                    newUpdateVisible: false,
                    taskInfo: {
                        id: '',
                        name: '',
                        startTime: '',
                        endTime: '',
                        count: 10,
                        status: 1,
                        price: 0,
                    }
                },
                adminType: 2,
                selectIds: [],
                selectDate: '',
            }
        },
        filters: {
        },
        methods: {
            init(){
                const orgPath = this.$route.path
                // this.$router.push({ path: '/task_mgr/task_sub_mgr', query:{taskId:1, orgPath: orgPath} });
                let user = sessionStorage.getItem('user');
                this.adminType = JSON.parse(user).adminType
                this.uploadHeaders = {
                    token: sessionStorage.getItem('token'),
                    identity: 2
                }
                this.queryTaskClick()                
            },
            newQueryTaskClick(){
                this.tableData.pageNum = 1
                this.tableData.pageSize = 10
                this.queryTaskClick()   
            },
            queryTaskClick(){
                console.log(this.tableData.pageNum, this.tableData.pageSize);
                
                // 查询
                NProgress.start();
                let params = {
                    ...this.buildQueryParams(this.tableParams), 
                    pageNum: this.tableData.pageNum, 
                    pageSize: this.tableData.pageSize, 
                }
                queryHandDateByPageApi(params).then(data => {
                    this.tableData = data.result
                    this.tableData.total = Number.parseInt(this.tableData.total)
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            resetParamsClick(){
                this.tableParams.status = ''
                this.tableParams.queryStartTimes = []
                this.tableParams.orderBy = ''
                this.tableData.pageNum = 1
                this.tableData.pageSize = 10
            },
            buildQueryParams(tableParams){
                let newParams = {
                    ...this.tableParams
                }
                if (tableParams.queryStartTimes && tableParams.queryStartTimes[0]) {
                    newParams.queryStartTime = tableParams.queryStartTimes[0]
                }
                if (tableParams.queryStartTimes && tableParams.queryStartTimes[1]) {
                    newParams.queryEndTime = tableParams.queryStartTimes[1]
                }
                return newParams
            },
            insertTaskClick(){
                this.dialogTaskInfo.newUpdateTitle = '新增日期'
                this.dialogTaskInfo.newUpdateVisible = true
                this.dialogTaskInfo.taskInfo = {
                    id: '',
                    name: '',
                    startTime: '',
                    endTime: '',
                    sort: 0,
                    status: 1,
                }
                this.selectDate = ''
            },
            editTaskInfoClick(data){
                console.log("编辑日期", data);
                this.dialogTaskInfo.newUpdateTitle = '编辑日期'
                this.dialogTaskInfo.newUpdateVisible = true
                this.dialogTaskInfo.taskInfo = data
                this.selectDate = data.startDate
            },
            // deleteTaskClick(row){
            //     // 删除
            //     NProgress.start();
            //     let params = {
            //         ...row
            //     }
            //     deleteTaskByIdApi(params).then(data => {
            //         this.$message.success("删除成功")
                    
            //         this.resetParamsClick()
            //         this.queryTaskClick()
            //         NProgress.done();
            //     }).catch(error => {
            //         this.$message.error(error.message);
            //         NProgress.done();
            //     });
            // },
            changePage(index){
                console.log("翻页", index);
                this.tableData.pageNum += index
                this.queryTaskClick()
            },
            handleCurrentChange(data){
                this.tableData.pageNum = data
                this.queryTaskClick()
            },
            newUpdateTaskClick(){
                if (this.selectDate) {
                    this.dialogTaskInfo.taskInfo.startDate = this.selectDate
                } else {
                    this.$message.error("请选择日期")
                    return
                }
                if (this.dialogTaskInfo.taskInfo.id) {
                    // 更新
                    NProgress.start();
                    let params = {
                        ...this.dialogTaskInfo.taskInfo
                    }
                    addOrUpdateHandDateApi(params).then(data => {
                        this.$message.success("更新成功")
                        this.dialogTaskInfo.newUpdateVisible = false
                        // this.resetParamsClick()
                        // this.tableData.pageNum = 1
                        // this.tableData.pageSize = 10
                        this.queryTaskClick()
                        NProgress.done();
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                } else {
                    // 新增
                    NProgress.start();
                    let params = {
                        ...this.dialogTaskInfo.taskInfo
                    }
                    addOrUpdateHandDateApi(params).then(data => {
                        this.$message.success("新增成功")
                        this.dialogTaskInfo.newUpdateVisible = false
                        // this.resetParamsClick()
                        this.tableData.pageNum = 1
                        this.tableData.pageSize = 10
                        this.queryTaskClick()
                        NProgress.done();
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                }
            },
            toggleStatusClick(row){
                // 切换状态
                NProgress.start();
                let params = {
                    id: row.id,
                    status: row.status == 1 ? 2 : 1
                }
                updateHandDateStatusApi(params).then(data => {
                    this.$message.success("更新成功")
                    // this.resetParamsClick()
                    // this.tableData.pageNum = 1
                    // this.tableData.pageSize = 10
                    this.queryTaskClick()
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            handleSelectionChange(val) {
                this.selectIds = val.map(item => item.id);
            },
            batchOnlineClick(){
                // 批量上线
                NProgress.start();
                let params = {
                    ids: this.selectIds,
                    status: 1
                }
                batchUpdateDateStatusApi(params).then(data => {
                    this.$message.success("批量上线成功")
                    // this.tableData.pageNum = 1
                    // this.tableData.pageSize = 10
                    this.queryTaskClick()
                    NProgress.done();
                }).catch(error => {
                    console.log("批量上线失败", error);
                    this.$message.error("批量上线失败");
                })
            },
            batchOfflineClick(){
                // 批量下线
                NProgress.start();
                let params = {
                    ids: this.selectIds,
                    status: 2
                }
                batchUpdateDateStatusApi(params).then(data => {
                    this.$message.success("批量下线成功")
                    // this.tableData.pageNum = 1
                    // this.tableData.pageSize = 10
                    this.queryTaskClick()
                    NProgress.done();
                }).catch(error => {
                    console.log("批量下线失败", error);
                    this.$message.error("批量下线失败");
                })
            }
        },
        mounted() {
            this.init()
        }
    }

</script>

<style lang="scss" scoped>
.desktop-main {
    width: calc(100% - 40px);
    padding: 20px;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
}
</style>


// WEBPACK FOOTER //
// date_mgr.vue?f7013f20